angular.module("vgresiduos").controller("SupplierCreateCtrl", [
	"$rootScope",
	function ($rootScope) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `organizacao/cadastrar-fornecedor`);
		};
	}
]);
